// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-params-discount__correction{position:relative}.event-params-discount__correction .info-icon{position:absolute;top:10px;left:-30px}", ""]);
// Exports
module.exports = exports;
